<template>
  <div>
    <div class="all-content">
      <!-- 头部 -->
      <!-- 中间 -->
      <div class="content"></div>
      <!-- 尾部 -->
      <div v-if="list.length != 0">
        <div
          class="foot"
          v-for="(item, index) in list"
          :key="index"
          @click="goDetails1(item)"
        >
          <div class="item">
            <div class="all-foot-imfg" v-if="item.img">
              <img :src="item.img" alt class="foot-img" :onerror="defaultImg" />
            </div>
            <div :class="item.img ? 'foot-right' : 'foot-one'">
              <h3>
                {{ item.title }}
              </h3>
              <p>{{ item.content }}{{ '...' }}</p>
              <div>
                <!-- <span class="time">{{ item.addTime }}</span> -->
                <span class="view">{{ item.browse }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>暂无数据</div>
      <el-pagination
        background
        layout="prev, pager, next,jumper"
        :total="allSize"
        @current-change="changePage"
        class="page"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import lib from '../api/index';
export default {
  props: {
    classifyId: Number,
    goPath: String
  },
  data() {
    return {
      defaultImg:
        'this.src="' + require('../../static/image/home/img1.jpg') + '"',
      list: [],
      allSize: 0,
      dataparams: {
        page: 1,
        size: 10
      }
    };
  },
  methods: {
    goDetails1(item) {
      if (item.link == null || item.link == '') {
        this.$emit('returnId', item.id);
        this.$router
          .push({
            path: '/pageDetails',
            query: {
              id: item.id,
              name: this.$route.name
            }
          })
          .catch(r => r);
      } else {
        location.href = item.link;
      }
    },
    changePage(val) {
      this.dataparams.page = val;
      if (this.$route.path == '/OnlineSearch') {
        this.getSearch();
      } else {
        this.getData();
      }
    },
    // 获取数据
    getData() {
      // if (this.$route.path == '/OnlineSearch') {
      //   this.dataparams.title = this.$route.query.title;
      // } else {
      //   this.dataparams.classifyId = this.classifyId;
      // }
      this.dataparams.classifyId = this.classifyId;
      lib
        .appInformationList({
          params: this.dataparams
        })
        .then(res => {
          console.log('2222', res);
          this.list = res.data.records;
          this.allSize = parseInt(res.data.total);
          for (let i = 0; i < this.list.length; i++) {
            // console.log(this.list[i].content)
            if (this.list[i].content !== '' && this.list[i].content !== null) {
              this.list[i].content = this.list[i].content
                .replace(/<\/?(img)[^>]*>/gi, '')
                .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n')
                .replace(/<br\/?>/gi, '\n')
                .replace(/<[^>/]+>/g, '')
                .replace(/(\n)?<\/([^>]+)>/g, '')
                .replace(/\u00a0/g, ' ')
                .replace(/&nbsp;/g, ' ')
                .replace(/<\/?(img)[^>]*>/gi, '')
                .replace(/&amp;/g, '&')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&#39;/g, "'")
                .replace(/&quot;/g, '"')
                .replace(/<\/?.+?>/g, '')
                .replace(/&ldquo/g, '')
                .replace(/&rdquo/g, '');
              this.list[i].content = this.list[i].content.slice(0, 150);
            }
          }
          console.log(this.list);
        });
    },
    // 搜索的数据
    getSearch() {
      this.dataparams.title = this.$route.query.title;
      lib
        .searchList({
          params: this.dataparams
        })
        .then(r => {
          console.log('搜索数据', r);
          this.list = r.data.records;
          this.allSize = parseInt(r.data.total);
          for (let i = 0; i < this.list.length; i++) {
            // console.log(this.list[i].content)
            if (this.list[i].content !== '' && this.list[i].content !== null) {
              this.list[i].content = this.list[i].content
                .replace(/<\/?(img)[^>]*>/gi, '')
                .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n')
                .replace(/<br\/?>/gi, '\n')
                .replace(/<[^>/]+>/g, '')
                .replace(/(\n)?<\/([^>]+)>/g, '')
                .replace(/\u00a0/g, ' ')
                .replace(/&nbsp;/g, ' ')
                .replace(/<\/?(img)[^>]*>/gi, '')
                .replace(/&amp;/g, '&')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&#39;/g, "'")
                .replace(/&quot;/g, '"')
                .replace(/<\/?.+?>/g, '')
                .replace(/&ldquo/g, '')
                .replace(/&rdquo/g, '');
              this.list[i].content = this.list[i].content.slice(0, 150);
            }
          }
        });
    }
  },
  mounted() {
    console.log(this.classifyId);
    if (this.$route.path == '/OnlineSearch') {
      this.getSearch();
    } else {
      this.getData();
    }
  }
};
</script>
<style scoped>
.all-content {
  width: 1100px;
  margin: 0 auto;
}
.content {
  margin-top: 20px;
  position: relative;
}
.first-img {
  vertical-align: top;
  width: 640px;
  overflow: hidden;
}
.first-img:hover {
  transition: transform 2s ease 0s;
  transform: scale(1.4);
}
.first-title {
  background-image: url(../assets/img/bg2.png);
  width: 592px;
  position: absolute;
  bottom: 4px;
  color: white;
  font-size: 18px;
  line-height: 32px;
  padding: 8px 24px 16px 24px;
  overflow: hidden;
  height: 52px;
}
.first-left {
  display: inline-block;
  overflow: hidden;
}
.first-right {
  background-color: rgb(245, 245, 245);
  width: 430px;
  /* display: inline-block; */
  float: right;
  height: 40px;
}

.top-hot {
  background-color: rgb(1, 82, 147);
  width: 100px;
  color: white;
  height: 40px;
  line-height: 40px;
  font-weight: bolder;
  font-size: 20px;
  text-align: center;
}
.top-hot-content {
  background-image: url(../assets/img/list07.jpg);
  background-repeat: repeat-y;
}
.top-hot-content ul li {
  list-style: none;
  cursor: pointer;
}
.list-one {
  /* background-image: url(../assets/image/list09.jpg); */
  background-repeat: no-repeat;
  background-position: left;
  margin-left: -41px;
  padding-left: 30px;
  margin-bottom: 53px;
}

.list-one span {
  color: #9e9e9e;
  font-size: 14px;
}
.list-one p {
  color: #015293;
  font-size: 16px;
  margin-top: 5px;
}
.foot a {
  text-decoration: none;
  color: inherit;
}
.foot {
  width: 100%;
  /* height: 150px; */
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.foot-right:hover h3 {
  color: red;
}
.foot-one:hover h3 {
  color: red;
}
.all-foot-imfg {
  width: 220px;
  overflow: hidden;
  display: inline-block;
}
.foot-img {
  width: 220px;
  vertical-align: top;
  display: inline-block;
}
.foot-img:hover {
  transition: transform 2s ease 0s;
  transform: scale(1.4);
}
.foot-right {
  /* display: inline-block; */
  width: 850px;
  /* height: 200px; */
  float: right;
  /* background-color: lightcoral; */
  /* margin-top: -15px; */
}
.foot-one {
  width: 1100px;
}
.foot-right h3 {
  font-size: 20px;
}
.foot-right p {
  float: left;
  width: 100%;
  overflow: hidden;
  font-size: 16px;
  color: #888888;
  line-height: 20px;
  margin-top: 0px;
}
.foot-right span {
  /* float: left; */
  font-size: 14px;
  color: #c5c5c5;
  margin-right: 25px;
  padding-left: 17px;
}
.time {
  background: url(../../static/img/list10.jpg) no-repeat 0 center;
}
.view {
  background: url(../../static/img/list11.jpg) no-repeat 0 center;
}

.foot-one h3 {
  font-size: 20px;
}
.foot-one p {
  /* float: left; */
  width: 100%;
  overflow: hidden;
  font-size: 16px;
  color: #888888;
  line-height: 20px;
  margin-top: 10px;
  padding-bottom: 10px;
}
.foot-one span {
  /* float: left; */
  font-size: 14px;
  color: #c5c5c5;
  margin-right: 25px;
  padding-left: 17px;
}
.foot-right a {
  text-decoration: none;
  color: black;
}
.foor-one a {
  text-decoration: none;
  color: black;
}
.page {
  margin-top: 50px;
  margin-bottom: 30px;
  position: relative;
  display: flex;
  justify-content: center;
}
</style>
<style lang="scss" scoped>
.item {
  height: 150px;
  overflow: hidden;
  .foot-right {
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    p {
      flex-grow: 1;
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SecondComponent.vue